import submitCommand from '../../../services/submitCommand';
import cacheService from '../../../services/cacheService';

export const updatePathwayDescription = (id: string, description: string, initiatingUserId: string) => {
  cacheService.remove(`/v1/workflows/${id}`);
  const cmd = { id, description, initiatingUserId };
  return submitCommand(id, cmd, 'SetWorkflowDescription', 'WorkflowDescriptionSet', 'WorkflowError');
};
